import { useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Creates a Portal wrapper used to render the specified children into a DOM node
 *  that exists outside the DOM hierarchy of the parent component
 * When using ReactDOM.createPortal with Next JS, error will occur
 *   because the container DOM node will not be present with SSR
 * @param {ReactNode} children
 * @param {string} selector - DOM node identifier
 */
export function ClientOnlyPortal({ children, selector }) {
  const ref = useRef();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    ref.current = document.querySelector(selector);
    setMounted(true);
  }, [selector]);

  return mounted ? createPortal(children, ref.current) : null;
}
